// campaignAPI.js — shared by all Campaign screens
import AsyncStorage from '@react-native-async-storage/async-storage';

export const API_BASE = 'https://api.jobeng.ai';
export const API_KEY  = '16a0651c78da416445e9c2946fb72fd9a6e4ce4a71ba610db15251050c3462ef';

export const getH = async () => {
  const tok = await AsyncStorage.getItem('auth_token').catch(() => null)
            || await AsyncStorage.getItem('token').catch(() => null);
  return {
    'Content-Type': 'application/json',
    'x-api-key': API_KEY,
    ...(tok ? { Authorization: `Bearer ${tok}` } : {}),
  };
};

export const getBizId = async () => {
  const id = await AsyncStorage.getItem('company_id').catch(() => null)
           || await AsyncStorage.getItem('company_id').catch(() => null);
  return parseInt(id) || 0;
};

export const fmtCurrency = (v, sym = '£') =>
  `${sym}${parseFloat(v || 0).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const fmtDate = d =>
  d ? new Date(d).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' }) : '—';

export const normalizeCampaign = raw => ({
  id:           raw.id           || raw.campaign_id   || String(Date.now()),
  name:         raw.name         || raw.campaign_name || raw.title       || 'Untitled Campaign',
  description:  raw.description  || '',
  status:       raw.status       || 'Planning',
  budget:       parseFloat(raw.budget || raw.total_budget || 0),
  spent:        parseFloat(raw.spent  || raw.budget_spent  || 0),
  reach:        raw.reach        || raw.total_reach   || 0,
  engagement:   parseFloat(raw.engagement || raw.engagement_rate || 0),
  impressions:  parseInt(raw.impressions || 0),
  clicks:       parseInt(raw.clicks || 0),
  conversions:  parseInt(raw.conversions || 0),
  startDate:    raw.startDate    || raw.start_date    || raw.startdate   || null,
  endDate:      raw.endDate      || raw.end_date      || raw.enddate     || null,
  platforms:    Array.isArray(raw.platforms) ? raw.platforms : (raw.platforms ? raw.platforms.split(',') : []),
  objectives:   Array.isArray(raw.objectives) ? raw.objectives : [],
  targetAudience: raw.targetAudience || raw.target_audience || '',
  tags:         Array.isArray(raw.tags) ? raw.tags : [],
  businessId:   raw.company_id  || raw.businessId   || 1,
  createdAt:    raw.created_at   || raw.createdAt     || null,
  updatedAt:    raw.updated_at   || raw.updatedAt     || null,
  _raw: raw,
});

// ─── Social Media Posting ─────────────────────────────────────────────────────
const PLATFORM_CONFIG = {
  LinkedIn:        { color: '#0077B5', icon: 'linkedin',        maxChars: 3000 },
  Twitter:         { color: '#1DA1F2', icon: 'twitter',         maxChars: 280  },
  'X (Twitter)':   { color: '#000000', icon: 'twitter',         maxChars: 280  },
  Instagram:       { color: '#E1306C', icon: 'instagram',       maxChars: 2200 },
  Facebook:        { color: '#1877F2', icon: 'facebook',        maxChars: 63206},
  Email:           { color: '#0e4e96', icon: 'email-outline',   maxChars: null },
  'Job Boards':    { color: '#28a745', icon: 'briefcase-outline',maxChars: null },
  'Industry Forums':{color:'#fd7e14', icon: 'forum-outline',    maxChars: null },
  Website:         { color: '#6c757d', icon: 'web',             maxChars: null },
};

export const getPlatformConfig = p => PLATFORM_CONFIG[p] || { color: '#0e4e96', icon: 'share-variant', maxChars: null };

export const postToSocialPlatform = async (platform, content, campaignId, mediaUrl = null) => {
  const h = await getH();
  const payload = {
    platform: platform.toLowerCase().replace(/\s+/g, '_'),
    content,
    campaign_id: campaignId,
    media_url:   mediaUrl,
    scheduled_at: new Date().toISOString(),
  };
  try {
    const res = await fetch(`${API_BASE}/api/social/post`, {
      method: 'POST', headers: h, body: JSON.stringify(payload),
    });
    const json = await res.json().catch(() => ({}));
    return { ok: res.ok || json.success, data: json.data || json, platform };
  } catch (e) {
    return { ok: false, error: e.message, platform };
  }
};

export const postToPlatforms = async (platforms, content, campaignId) => {
  const results = await Promise.allSettled(
    platforms.map(p => postToSocialPlatform(p, content, campaignId))
  );
  return results.map(r => r.status === 'fulfilled' ? r.value : { ok: false, error: r.reason?.message });
};

export const STATUS_COLORS = {
  Active:    { text: '#155724', bg: '#d4edda', dot: '#28a745' },
  active:    { text: '#155724', bg: '#d4edda', dot: '#28a745' },
  Scheduled: { text: '#856404', bg: '#fff3cd', dot: '#ffc107' },
  scheduled: { text: '#856404', bg: '#fff3cd', dot: '#ffc107' },
  Completed: { text: '#383d41', bg: '#e2e3e5', dot: '#6c757d' },
  completed: { text: '#383d41', bg: '#e2e3e5', dot: '#6c757d' },
  Paused:    { text: '#721c24', bg: '#f8d7da', dot: '#dc3545' },
  paused:    { text: '#721c24', bg: '#f8d7da', dot: '#dc3545' },
  Planning:  { text: '#0c5460', bg: '#d1ecf1', dot: '#17a2b8' },
  Draft:     { text: '#0c5460', bg: '#d1ecf1', dot: '#17a2b8' },
};
